import { localScore } from '../utils/textSimilarity';
import { convertForDisplay } from '../utils/kanjiConverter';

/**
 * サーバープロキシ経由でClaude採点APIを呼ぶ
 * 本番: /api/score（Vercelサーバーレス関数）
 * 開発: /api/score（setupProxy.js経由）
 */
async function callScoreApi(original, transcript, mode, grade) {
  try {
    const res = await fetch('/api/score', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ original, transcript, mode, grade }),
    });
    if (!res.ok) {
      console.warn('Claude採点API エラー:', res.status, '→ ローカル採点に切り替えます');
      return null;
    }
    const data = await res.json();
    // score が null = APIキーなし or パース失敗 → フォールバック
    if (!data.score) return null;
    return data;
  } catch (e) {
    console.warn('Claude採点API 接続エラー → ローカル採点に切り替えます', e);
    return null;
  }
}

/**
 * 1行の音読採点（れんしゅうモード）
 */
export async function scoreOneLine(original, transcript, grade) {
  const result = await callScoreApi(original, transcript, 'renshyu', grade);
  if (result) {
    const fallback = localScore(original, transcript);
    return {
      score:    result.score    ?? fallback.score,
      stars:    result.stars    ?? fallback.stars,
      feedback: result.feedback ?? fallback.feedback,
      display:  convertForDisplay(result.display) ?? fallback.display,
    };
  }
  return localScore(original, transcript);
}

/**
 * 通し読みの総合採点（ほんばんモード）
 */
export async function scoreFullReading(original, transcript, grade) {
  const result = await callScoreApi(original, transcript, 'honban', grade);
  if (result) {
    const fallback = localScore(original, transcript);
    return {
      score:    result.score    ?? fallback.score,
      stars:    result.stars    ?? fallback.stars,
      feedback: result.feedback ?? fallback.feedback,
      details:  result.details  ?? '',
      display:  convertForDisplay(result.display) ?? fallback.display,
    };
  }
  const fallback = localScore(original, transcript);
  return { ...fallback, details: '' };
}

/**
 * Claude Vision OCR：写真/PDFから音読テキストを抽出（プロキシ経由）
 */
export async function extractTextFromImage(base64Image, mediaType = 'image/jpeg') {
  const res = await fetch('/api/vision', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ base64Image, mediaType }),
  });

  if (!res.ok) throw new Error(`Vision API エラー: ${res.status}`);
  const data = await res.json();
  if (!data.text) throw new Error('テキストを　みつけられませんでした');
  return data.text;
}
